export default __webpack_public_path__ + "ac9cf12.png";